import React from "react";
import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../contants/Endpoints";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reuseable/Spinner";
const EditCustomerComponent = loadable(
  () => import("../../components/Customer/EditCustomer")
);
type Props = {};

const EditCustomer = (props: Props) => {
  const { id } = useParams();
  const { data: singleCustomer, isPending: singleCustomerLoading } = useGetHook(
    {
      queryKey: [`customer-${id}`],
      url: `${APIS.CUSTOMER}${id}/`,
      params: {},
    }
  );
  const {
    isLoading,
    mutateAsync: updateCustomerAsync,
    data,
  } = usePatchHook({
    queryKey: [`customer`, `customer-${id}`],
    navigateURL: "/customer",
  });
  const handleUpdateCustomer = async (values: any) => {
    const url = `${APIS.CUSTOMER}${id}/`;
    const formData = {
      name: values.title,
      address: values.address,
      contact_number: values.phoneNumber,
      email: values.email,
    };
    try {
      const res = await updateCustomerAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {singleCustomerLoading ? (
        <Spinner />
      ) : (
        <EditCustomerComponent
          singleCustomer={singleCustomer}
          handleUpdateCustomer={handleUpdateCustomer}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default EditCustomer;
